import { render } from "./ReferendumView.vue?vue&type=template&id=1c6a0554&scoped=true&ts=true"
import script from "./ReferendumView.vue?vue&type=script&lang=ts"
export * from "./ReferendumView.vue?vue&type=script&lang=ts"

import "./ReferendumView.vue?vue&type=style&index=0&id=1c6a0554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6a0554"]])

export default __exports__